import { LocationLineItemModel, CommUnityLineItemModel } from 'Models';
import { LINE_ITEM_PRICE_MODEL } from 'common/enums/lineItemPriceModel';

export default class CommUnityLocationLineItemModel extends LocationLineItemModel {
  /**
   * @returns {CommUnityLineItemModel}
   */
  get parent() {
    return super.parent;
  }

  get recurringPrice() {
    return this.parent.recurringPrice;
  }

  set recurringPrice(value) {
    // Do nothing
  }

  get discount() {
    return this.parent.discount;
  }

  get recurringDiscount() {
    return this.parent.recurringDiscount;
  }

  /**
   * @returns {string}
   */
  get priceModelSelected() {
    return this.parent.priceModelSelected;
  }

  /**
   * @returns {boolean}
   */
  get priceModelSelectedEditable() {
    return this.parent.priceModelSelectedEditable;
  }

  /**
   * @returns {number}
   */
  get upfrontDiscountPercentage() {
    return CommUnityLineItemModel.calcDiscountPercentage(this.dealerNet, this.discount);
  }

  /**
   * @returns {number}
   */
  get recurringDiscountPercentage() {
    return CommUnityLineItemModel.calcDiscountPercentage(this.recurringPrice, this.recurringDiscount);
  }

  /**
   * @returns {number}
   */
  get upfrontAdjusted() {
    return this.dealerNet - this.discount;
  }

  /**
   * @returns {number}
   */
  get upfrontExtended() {
    return this.quantity * this.upfrontAdjusted;
  }

  /**
   * @returns {number}
   */
  get recurringAdjusted() {
    return this.recurringPrice - this.recurringDiscount;
  }

  /**
   * @returns {number}
   */
  get recurringExtended() {
    return this.quantity * this.recurringAdjusted;
  }

  get total() {
    return this.priceModelSelected === LINE_ITEM_PRICE_MODEL.RECURRING ? this.recurringExtended : this.upfrontExtended;
  }

  get upfrontTotal() {
    return this.priceModelSelected === LINE_ITEM_PRICE_MODEL.NON_RECURRING ? this.upfrontExtended : 0;
  }

  get recurringTotal() {
    return this.priceModelSelected === LINE_ITEM_PRICE_MODEL.RECURRING ? this.recurringExtended : 0;
  }
}
